import { useCatalogStats } from '../../hooks/useCatalogStats'
import { GridBackground } from '../ui'
import SectionHeader from './SectionHeader'

// The numbers here used to count up from 0 on scroll, so a fast scroller or a
// slow device saw "0 tools, hand-tested". They render at their real value now.
export default function CurationDiscipline() {
  const { roundedToolsText } = useCatalogStats()

  return (
    <section id="curation" className="relative">
      <GridBackground className="py-16 md:py-24">
        <div className="mx-auto max-w-6xl px-5 relative z-10">
          <SectionHeader
            index="04"
            label="Curation discipline"
            title="Why this catalogue isn't another scrape."
            className="mb-4"
          />

        <div className="mt-2 grid grid-cols-1 gap-[18px] md:grid-cols-[1.1fr_1fr] md:gap-16">
          {/* Prose column */}
          <div className="text-pretty">
            <p className="mb-3.5 text-base leading-[1.65] text-ink-2">
              Every listing is checked by a person before it goes live: the tool is opened, the
              core feature is tried, and the free tier is written down with its real limits.{' '}
              <strong className="font-semibold text-ink">
                No scraping. No copy-paste from press releases.
              </strong>
            </p>
            <p className="mb-3.5 text-base leading-[1.65] text-ink-2">
              When a vendor changes its pricing or a link breaks, the listing is updated and
              re-dated.{' '}
              <strong className="font-semibold text-ink">
                Broken tools are removed, not buried.
              </strong>
            </p>
            <p className="text-base leading-[1.65] text-ink-2">
              The Tool Finder scores tools against your answers with plain rules (use case,
              budget, platform), and every suggestion comes with the reason it was picked.
            </p>
          </div>

          {/* Stats column — 3 stats in a single column on mobile, side-by-side at md+. Removed the unbacked "tools removed in 2026" stat. */}
          <div
            aria-label="Catalogue facts"
            className="grid grid-cols-1 gap-px self-start overflow-hidden rounded-xl border border-line bg-line sm:grid-cols-2"
          >
            <div className="bg-bg p-5 md:p-7">
              <div className="text-[32px] font-semibold leading-none tracking-tight tabular-nums text-ink md:text-[40px]">
                {roundedToolsText}
              </div>
              <div className="mt-2 text-[13px] leading-[1.45] text-muted">
                tools, each checked<br />before it was listed
              </div>
            </div>

            <div className="bg-bg p-5 md:p-7">
              <div className="text-[32px] font-semibold leading-none tracking-tight tabular-nums text-ink md:text-[40px]">
                0
              </div>
              <div className="mt-2 text-[13px] leading-[1.45] text-muted">
                ratings or picks<br />that can be bought
              </div>
            </div>
          </div>
        </div>
        </div>
      </GridBackground>
    </section>
  )
}
